module.exports = __webpack_public_path__ + "img/025-drawkit-server-woman-colour.629522f7.svg";